import axios from "axios";
import { getNodeServerUrl } from "../../utils/getNodeUrl";

/**
 * Get all towns
 * @returns {Promise} - Promise object with town data
 */
export const getAllTownsApi = async () => {
  const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/town/all`,
    method: "get",
  };

  try {
    const response = await axios(options);

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
        count: response.data.count,
      };
    } else {
      throw Error("Failed to fetch towns");
    }
  } catch (err) {
    console.error("Error fetching towns:", err);
    return {
      success: false,
      message: err.message,
    };
  }
};

/**
 * Get towns by state code
 * @param {string} stateCode - State code
 * @returns {Promise} - Promise object with town data
 */
export const getTownsByStateApi = async (stateCode) => {
  const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/town/state/${stateCode}`,
    method: "get",
  };

  try {
    const response = await axios(options);

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
        count: response.data.count,
      };
    } else {
      throw Error("Failed to fetch towns");
    }
  } catch (err) {
    console.error("Error fetching towns by state:", err);
    return {
      success: false,
      message: err.message,
    };
  }
};

/**
 * Get town details by town code (fetch city_type_id from PostgreSQL)
 * @param {string} townCode - Town code
 * @returns {Promise} - Promise object with town details
 */
export const getTownByCodeApi = async (townCode) => {
  const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/town/code/${townCode}`,
    method: "get",
  };

  try {
    const response = await axios(options);

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      throw Error("Failed to fetch town details");
    }
  } catch (err) {
    console.error("Error fetching town by code:", err);
    return {
      success: false,
      message: err.message,
    };
  }
};
